(function () {
  var promoConfig = window.tnrPromotion || {};
  var promotionEnabled = promoConfig.enabled !== false;
  var promoName = promoConfig.name || 'Promotion';
  var promoPercent = Number(promoConfig.percent || 15);
  var estimatePromotionPrices = promoConfig.showEstimatedPrices === true;
  var promotionUrl = normalizeStorefrontUrl(promoConfig.landingUrl || '');
  var legacyPromotionUrls = String(promoConfig.legacyUrls || '')
    .split(/[\n,]+/)
    .map(normalizeStorefrontUrl)
    .filter(Boolean);
  var configuredCollectionHandles = String(promoConfig.collectionHandles || '')
    .split(/[\s,]+/)
    .map(function (handle) { return handle.trim(); })
    .filter(Boolean);
  var eligibleCollectionHandles = configuredCollectionHandles;
  var offerSourceParam = 'fd_source';
  var offerSourceValue = 'fathers-day';
  var offerBreadcrumbStorageKey = 'tnr:offer-breadcrumb';
  var offerBreadcrumbMaxAge = 60 * 60 * 1000;
  var offerBreadcrumbLabel = promoConfig.breadcrumbLabel || "Father's Day Deals";

  if (promotionUrl && matchesLegacyPromotionUrl(window.location.href)) {
    window.location.replace(promotionUrl);
    return;
  }

  function normalizeStorefrontUrl(url) {
    var value = String(url || '').trim();

    if (!value) return '';

    if (value.indexOf('shopify://pages/') === 0) {
      return '/pages/' + value.replace('shopify://pages/', '').split('?')[0].split('#')[0];
    }

    if (value.indexOf('shopify://collections/') === 0) {
      return '/collections/' + value.replace('shopify://collections/', '').split('?')[0].split('#')[0];
    }

    if (value.indexOf('shopify://products/') === 0) {
      return '/products/' + value.replace('shopify://products/', '').split('?')[0].split('#')[0];
    }

    try {
      var parsedUrl = new URL(value, window.location.origin);
      return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
    } catch (error) {
      return '';
    }
  }

  function isCurrentPath(url) {
    try {
      return window.location.pathname === new URL(url, window.location.origin).pathname;
    } catch (error) {
      return window.location.pathname === url;
    }
  }

  function getComparableUrl(url) {
    var normalizedUrl = normalizeStorefrontUrl(url);
    if (!normalizedUrl) return null;

    try {
      var parsedUrl = new URL(normalizedUrl, window.location.origin);
      return {
        path: parsedUrl.pathname,
        search: parsedUrl.search,
        hash: parsedUrl.hash
      };
    } catch (error) {
      return null;
    }
  }

  function matchesLegacyPromotionUrl(url) {
    var target = getComparableUrl(url);
    if (!target) return false;

    return legacyPromotionUrls.some(function (legacyUrl) {
      var legacy = getComparableUrl(legacyUrl);
      if (!legacy || target.path !== legacy.path) return false;
      if (legacy.search && target.search !== legacy.search) return false;
      if (legacy.hash && target.hash !== legacy.hash) return false;
      return true;
    });
  }

  function rewriteLegacyPromotionLinks() {
    if (!promotionUrl || !legacyPromotionUrls.length) return;

    document.querySelectorAll('a[href]').forEach(function (link) {
      if (matchesLegacyPromotionUrl(link.getAttribute('href'))) {
        link.setAttribute('href', promotionUrl);
      }
    });
  }

  function getOfferBreadcrumbUrl() {
    return promotionUrl || '/pages/fathers-day';
  }

  function isPromotionLandingPath(pathname) {
    var offerUrl = getOfferBreadcrumbUrl();

    try {
      return pathname === new URL(offerUrl, window.location.origin).pathname;
    } catch (error) {
      return pathname === offerUrl || pathname === '/pages/fathers-day';
    }
  }

  function isPromotionLandingPage() {
    return isPromotionLandingPath(window.location.pathname) || !!document.querySelector('.fd-sale');
  }

  function appendOfferSource(url) {
    try {
      var parsedUrl = new URL(url, window.location.origin);

      if (!/^\/products\//.test(parsedUrl.pathname)) return url;

      parsedUrl.searchParams.set(offerSourceParam, offerSourceValue);
      return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
    } catch (error) {
      return url;
    }
  }

  function rememberOfferBreadcrumb(productUrl) {
    try {
      var parsedUrl = productUrl ? new URL(productUrl, window.location.origin) : null;
      var productPath = parsedUrl && /^\/products\//.test(parsedUrl.pathname) ? parsedUrl.pathname : '';
      window.sessionStorage.setItem(offerBreadcrumbStorageKey, JSON.stringify({
        label: offerBreadcrumbLabel,
        url: getOfferBreadcrumbUrl(),
        productPath: productPath,
        timestamp: Date.now()
      }));
    } catch (error) {
      // Storage can be blocked in private contexts. The URL param fallback still works.
    }
  }

  function getStoredOfferBreadcrumb() {
    try {
      var raw = window.sessionStorage.getItem(offerBreadcrumbStorageKey);
      if (!raw) return null;

      var value = JSON.parse(raw);
      if (!value || !value.timestamp || Date.now() - value.timestamp > offerBreadcrumbMaxAge) return null;
      return value;
    } catch (error) {
      return null;
    }
  }

  function hasOfferSourceParam() {
    try {
      return new URLSearchParams(window.location.search).get(offerSourceParam) === offerSourceValue;
    } catch (error) {
      return false;
    }
  }

  function hasOfferReferrer() {
    if (!document.referrer) return false;

    try {
      return isPromotionLandingPath(new URL(document.referrer).pathname);
    } catch (error) {
      return false;
    }
  }

  function getOfferBreadcrumbContext() {
    if (!/^\/products\//.test(window.location.pathname)) return null;

    var stored = getStoredOfferBreadcrumb();
    if (hasOfferSourceParam() || hasOfferReferrer()) {
      return {
        label: offerBreadcrumbLabel,
        url: getOfferBreadcrumbUrl()
      };
    }

    if (stored && stored.productPath === window.location.pathname) {
      return {
        label: stored.label || offerBreadcrumbLabel,
        url: stored.url || getOfferBreadcrumbUrl()
      };
    }

    return null;
  }

  function decorateOfferProductLinks() {
    if (!isPromotionLandingPage()) return;

    document.querySelectorAll('.fd-sale a[href*="/products/"]').forEach(function (link) {
      var nextHref = appendOfferSource(link.getAttribute('href') || '');
      if (nextHref) link.setAttribute('href', nextHref);

      link.addEventListener('click', function () {
        rememberOfferBreadcrumb(link.getAttribute('href'));
      }, { passive: true });
    });
  }

  function applyOfferBreadcrumb() {
    var context = getOfferBreadcrumbContext();
    if (!context) return;

    var breadcrumb = document.querySelector('[data-nr-breadcrumb], .shopify-section--main-product .breadcrumb');
    if (!breadcrumb) return;

    var firstLink = breadcrumb.querySelector('.breadcrumb__item:first-child .breadcrumb__link');
    if (!firstLink) return;

    firstLink.setAttribute('href', context.url);
    firstLink.textContent = context.label;
    firstLink.setAttribute('aria-label', 'Back to ' + context.label);
    breadcrumb.classList.add('nr-breadcrumb--offer-context');
  }

  function preserveOfferSourceOnProductLinks() {
    if (!getOfferBreadcrumbContext()) return;

    document.querySelectorAll('a[data-product-variation-link], .product-form__option-selector a[href*="/products/"]').forEach(function (link) {
      var nextHref = appendOfferSource(link.getAttribute('href') || '');
      if (nextHref) link.setAttribute('href', nextHref);

      link.addEventListener('click', function () {
        rememberOfferBreadcrumb(link.getAttribute('href'));
      }, { passive: true });
    });
  }

  function injectCollectionOffer() {
    if (!promotionEnabled) return;

    var match = window.location.pathname.match(/^\/collections\/([^/]+)/);
    if (!match || document.querySelector('[data-fd-collection-offer]')) return;

    if (eligibleCollectionHandles.indexOf(match[1]) === -1) return;

    var main = document.getElementById('main');
    if (!main) return;

    var banner = document.createElement('div');
    banner.className = 'fd-collection-offer';
    banner.setAttribute('data-fd-collection-offer', '');
    banner.setAttribute('role', 'region');
    banner.setAttribute('aria-label', promoName + ' savings');
    banner.innerHTML =
      '<div class="container fd-collection-offer__inner">' +
      '<span class="fd-collection-offer__badge">' + escapeHtml(formatPromotionTemplate(promoConfig.collectionBadgeTemplate || '[name] [percent]% off')) + '</span>' +
      (promoConfig.collectionNote ? '<p>' + escapeHtml(promoConfig.collectionNote) + '</p>' : '') +
      (promoConfig.collectionLinkText && promotionUrl ? '<a href="' + escapeAttribute(promotionUrl) + '">' + escapeHtml(promoConfig.collectionLinkText) + '</a>' : '') +
      '</div>';

    main.insertBefore(banner, main.firstChild);
  }

  function isOfferFlowPath() {
    if (!promotionEnabled) return false;

    if (promotionUrl && isCurrentPath(promotionUrl)) return true;

    var match = window.location.pathname.match(/^\/collections\/([^/]+)/);
    if (match && eligibleCollectionHandles.indexOf(match[1]) !== -1) return true;

    return !!document.querySelector('[data-fd-pdp-savings], [data-native-pdp-savings], [data-fd-collection-offer], .fd-pdp-savings, .product-meta--fd-sale');
  }

  function suppressOfferFlowPopups() {
    if (!isOfferFlowPath()) return;

    var popupTextPattern = /Not sure what product is right|Recommended Products Quiz|Book a Call|Take The Quiz/i;
    var candidates = document.querySelectorAll('[role="dialog"], [aria-modal="true"], .needsclick, .kl-private-reset-css-Xuajs1');
    var themeUiSelector = '#search-drawer, #mobile-menu-drawer, #mini-cart, .pswp, product-image-zoom, predictive-search-drawer, mobile-navigation, announcement-bar, announcement-bar-item, #nr-search-panel';

    candidates.forEach(function (node) {
      if (node.matches && node.matches(themeUiSelector)) return;
      if (node.closest && node.closest(themeUiSelector)) return;

      var text = node.textContent || '';
      var className = String(node.className || '');
      var isKlaviyoLike = className.indexOf('kl-private-reset-css') !== -1 || className.indexOf('needsclick') !== -1;

      if (!isKlaviyoLike && !popupTextPattern.test(text)) return;
      if (!popupTextPattern.test(text)) return;

      node.setAttribute('hidden', '');
      node.style.display = 'none';
      node.style.visibility = 'hidden';
      document.body.classList.remove('klaviyo-prevent-body-scrolling');
      document.documentElement.classList.remove('klaviyo-prevent-body-scrolling');
    });
  }

  function watchOfferFlowPopups() {
    if (!isOfferFlowPath()) return;

    suppressOfferFlowPopups();

    if (!('MutationObserver' in window)) return;

    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;

      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        suppressOfferFlowPopups();
      });
    });

    /* SCROLL-LOCK FIX (2026-06-10): keep watching for the page's lifetime and
       also watch class changes. Klaviyo popups fired on time/scroll-depth
       triggers re-add klaviyo-prevent-body-scrolling AFTER a one-off 20s
       window, which froze the page with the popup suppressed (invisible). */
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function formatMoney(cents) {
    var settings = window.themeVariables && window.themeVariables.settings;
    var format = settings && settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings && settings.moneyFormat;

    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents, format);
    }

    var value = (Number(cents || 0) / 100).toFixed(2);
    if (!format) return '$ ' + value;

    return format.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(Number(value))));
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character];
    });
  }

  function escapeAttribute(value) {
    return escapeHtml(value).replace(/`/g, '&#96;');
  }

  function formatPromotionTemplate(template) {
    return String(template || '')
      .replace(/\[name\]/g, promoName)
      .replace(/\[percent\]/g, String(promoPercent));
  }

  function getPromotionBasisPrice(container, variant) {
    var price = Number(variant && variant.price || 0);

    if (container && container.getAttribute('data-fd-price-basis') === 'compare-at') {
      var compareAtPrice = Number(variant && variant.compare_at_price || 0);

      if (compareAtPrice > price) {
        return compareAtPrice;
      }
    }

    return price;
  }

  function getPromotionSalePrice(price, percent) {
    var savings = Math.floor(price * percent / 100);

    return price - savings;
  }

  function updateSavingsCard(card, variant) {
    if (!card) return;

    var productMeta = card.closest('product-meta');
    var saveEl = card.querySelector('[data-fd-save-amount]');

    if (!variant) {
      card.setAttribute('hidden', '');
      if (productMeta) productMeta.classList.remove('product-meta--fd-sale');
      return;
    }

    var variantPrice = Number(variant.price || 0);
    if (!promotionEnabled || !estimatePromotionPrices || variant.available === false || variantPrice <= 0) {
      card.setAttribute('hidden', '');
      if (productMeta) productMeta.classList.remove('product-meta--fd-sale');
      return;
    }

    var percent = Number(card.getAttribute('data-fd-sale-percent') || promoPercent || 15);
    var price = getPromotionBasisPrice(card, variant);
    var salePrice = getPromotionSalePrice(price, percent);
    var saleEl = card.querySelector('[data-fd-sale-price]');
    var compareEl = card.querySelector('[data-fd-compare-price]');
    var savings = price - salePrice;

    if (saleEl) saleEl.textContent = formatMoney(salePrice);
    if (compareEl) compareEl.textContent = formatMoney(price);
    if (saveEl) saveEl.textContent = 'Save ' + formatMoney(savings);
    if (productMeta) productMeta.classList.add('product-meta--fd-sale');
    card.removeAttribute('hidden');
  }

  function renderUnitPriceHtml(variant) {
    if (!variant || !variant.unit_price_measurement) return '';

    var measurement = variant.unit_price_measurement;
    var referenceValue = '';

    if (measurement.reference_value !== 1) {
      referenceValue = '<span class="unit-price-measurement__reference-value">' + escapeHtml(measurement.reference_value) + '</span>';
    }

    return '<div class="price text--subdued">' +
      '<div class="unit-price-measurement">' +
      '<span class="unit-price-measurement__price">' + formatMoney(variant.unit_price) + '</span>' +
      '<span class="unit-price-measurement__separator">/</span>' +
      referenceValue +
      '<span class="unit-price-measurement__reference-unit">' + escapeHtml(measurement.reference_unit || '') + '</span>' +
      '</div>' +
      '</div>';
  }

  function updateProductMetaPromotionPrice(productMeta, variant) {
    if (!productMeta) return;

    var priceList = productMeta.querySelector('[data-product-price-list][data-fd-sale-percent]');
    if (!priceList) return;

    if (!variant) {
      priceList.innerHTML = '';
      return;
    }

    var variantPrice = Number(variant.price || 0);
    if (!promotionEnabled || !estimatePromotionPrices || variant.available === false || variantPrice <= 0) {
      return;
    }

    var percent = Number(priceList.getAttribute('data-fd-sale-percent') || promoPercent || 15);
    var price = getPromotionBasisPrice(priceList, variant);
    var salePrice = getPromotionSalePrice(price, percent);
    var strings = window.themeVariables && window.themeVariables.strings || {};

    priceList.innerHTML =
      '<span class="price price--highlight price--large">' +
      '<span class="visually-hidden">' + escapeHtml(strings.productSalePrice || 'Sale price') + '</span>' +
      formatMoney(salePrice) +
      '</span>' +
      '<span class="price price--compare">' +
      '<span class="visually-hidden">' + escapeHtml(strings.productRegularPrice || 'Regular price') + '</span>' +
      formatMoney(price) +
      '</span>' +
      renderUnitPriceHtml(variant);
  }

  function updateStickyPromotionPrice(priceEl, variant) {
    if (!priceEl) return;

    var settings = window.themeVariables && window.themeVariables.settings;
    var currencyFormat = settings && settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings && settings.moneyFormat;

    if (!variant) {
      priceEl.textContent = '';
      return;
    }

    var variantPrice = Number(variant.price || 0);
    if (!promotionEnabled || !estimatePromotionPrices || variant.available === false || variantPrice <= 0) {
      priceEl.innerHTML = formatMoney(variantPrice, currencyFormat);
      return;
    }

    var percent = Number(priceEl.getAttribute('data-fd-sale-percent') || promoPercent || 15);
    var price = getPromotionBasisPrice(priceEl, variant);
    var salePrice = getPromotionSalePrice(price, percent);

    priceEl.innerHTML =
      '<span data-fd-sticky-sale-price>' + formatMoney(salePrice, currencyFormat) + '</span>' +
      '<s class="text--subdued" data-fd-sticky-compare-price>' + formatMoney(price, currencyFormat) + '</s>';
  }

  function updateNativeSavingsCard(card, variant) {
    if (!card) return;

    var textEl = card.querySelector('[data-native-savings-text]');

    if (!variant) {
      if (textEl) textEl.textContent = '';
      card.setAttribute('hidden', '');
      return;
    }

    var price = Number(variant.price || 0);
    var compareAtPrice = Number(variant.compare_at_price || 0);

    if (variant.available === false || compareAtPrice <= price || price <= 0) {
      if (textEl) textEl.textContent = '';
      card.setAttribute('hidden', '');
      return;
    }

    var savings = compareAtPrice - price;
    var percent = compareAtPrice > 0 ? Math.round(savings * 100 / compareAtPrice) : 0;
    var compact = card.getAttribute('data-native-compact') === 'true';
    var template = compact
      ? card.getAttribute('data-native-savings-compact-template')
      : card.getAttribute('data-native-savings-template');

    if (textEl) {
      template = template || (compact ? 'Save [savings]' : 'Save [savings] ([percent])');
      textEl.textContent = template
        .replace(/\[savings\]/g, formatMoney(savings))
        .replace(/\[percent\]/g, percent + '%');
    }

    card.removeAttribute('hidden');
  }

  function buildFormSelector(formId, targetSelector) {
    formId = String(formId || '');
    targetSelector = targetSelector || '[data-fd-pdp-savings]';

    if (window.CSS && typeof window.CSS.escape === 'function') {
      return 'product-meta[form-id="' + window.CSS.escape(formId) + '"] ' + targetSelector;
    }

    return 'product-meta[form-id="' + formId.replace(/"/g, '\\"') + '"] ' + targetSelector;
  }

  function getFormId(form) {
    if (!form) return '';

    return form.getAttribute('id') || '';
  }

  document.addEventListener('variant:changed', function (event) {
    var form = event.target;
    var formId = getFormId(form);

    if (!formId || !event.detail) return;

    document.querySelectorAll(buildFormSelector(formId, '[data-fd-pdp-savings]')).forEach(function (card) {
      updateSavingsCard(card, event.detail.variant);
    });

    document.querySelectorAll(buildFormSelector(formId, '[data-product-price-list][data-fd-sale-percent]')).forEach(function (priceList) {
      updateProductMetaPromotionPrice(priceList.closest('product-meta'), event.detail.variant);
    });

    document.querySelectorAll(buildFormSelector(formId, '[data-native-pdp-savings]')).forEach(function (card) {
      updateNativeSavingsCard(card, event.detail.variant);
    });

    document.querySelectorAll('product-sticky-form[form-id="' + formId.replace(/"/g, '\\"') + '"] [data-fd-sticky-price]').forEach(function (priceEl) {
      updateStickyPromotionPrice(priceEl, event.detail.variant);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      rewriteLegacyPromotionLinks();
      decorateOfferProductLinks();
      applyOfferBreadcrumb();
      preserveOfferSourceOnProductLinks();
      injectCollectionOffer();
      watchOfferFlowPopups();
    });
  } else {
    rewriteLegacyPromotionLinks();
    decorateOfferProductLinks();
    applyOfferBreadcrumb();
    preserveOfferSourceOnProductLinks();
    injectCollectionOffer();
    watchOfferFlowPopups();
  }
})();
